import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import omit from 'lodash/omit';
import { push } from '../lib/redux-router';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import Paths from '../constants/Paths';
import { BoardMembershipRoles } from '../constants/Enums';
import CardModal from '../components/CardModal';

const mapStateToProps = (state) => {
  const { projectId } = selectors.selectPath(state);
  const allProjectsToLists = selectors.selectProjectsToListsForCurrentUser(state);
  const isCurrentUserManager = selectors.selectIsCurrentUserManagerForCurrentProject(state);
  const allBoardMemberships = selectors.selectMembershipsForCurrentBoard(state);
  const allLabels = selectors.selectLabelsForCurrentBoard(state);
  const currentUserMembership = selectors.selectCurrentUserMembershipForCurrentBoard(state);
  const pointSystem = selectors.selectPointSystemForCurrentBoard(state);
  const pointSystemId = pointSystem?.id;
  const isPointSystemEnabled = pointSystem ? pointSystem.isEnabled === true : false;

  const {
    id: cardId,
    name,
    description,
    dueDate,
    createdAt,
    creatorUserId,
    stopwatch,
    isSubscribed,
    isActivitiesFetching,
    isAllActivitiesFetched,
    isActivitiesDetailsVisible,
    isActivitiesDetailsFetching,
    boardId,
    listId,
  } = selectors.selectCurrentCard(state);

  const users = selectors.selectUsersForCurrentCard(state);
  const author = selectors.selectUserById(state, creatorUserId)?.name;
  const currentUserId = selectors.selectCurrentUserId(state);
  const currentUser = selectors.selectCurrentUser(state, currentUserId);
  const labels = selectors.selectLabelsForCurrentCard(state);
  const tasks = selectors.selectTasksForCurrentCard(state);
  const attachments = selectors.selectAttachmentsForCurrentCard(state);
  const activities = selectors.selectActivitiesForCurrentCard(state);

  let isCurrentUserEditor = false;
  let isCurrentUserEditorOrCanComment = false;

  if (currentUserMembership) {
    isCurrentUserEditor = currentUserMembership.role === BoardMembershipRoles.EDITOR;
    isCurrentUserEditorOrCanComment = isCurrentUserEditor || currentUserMembership.canComment;
  }

  if(currentUser.isSAdmin === true) {
    isCurrentUserEditor = true;
    isCurrentUserEditorOrCanComment = true;
  }

  

  // Получаем ContentViewPlan и DampingCoefficients для расчета totalPoints
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const contentViewPlan = selectors.selectContentViewPlanForCurrentBoardByYearMonth(
    state,
    currentYear,
    currentMonth,
  );
  const dampingCoefficients = selectors.selectDampingCoefficientsForPointSystem(state, pointSystemId);

  return {
    name,
    description,
    author,
    dueDate,
    stopwatch,
    createdAt,
    isSubscribed,
    isActivitiesFetching,
    isAllActivitiesFetched,
    isActivitiesDetailsVisible,
    isActivitiesDetailsFetching,
    listId,
    boardId,
    projectId,
    cardId,
    pointSystemId,
    users,
    labels,
    tasks,
    attachments,
    activities,
    allProjectsToLists,
    allBoardMemberships,
    allLabels,
    isPointSystemEnabled,
    contentCardDefaults: selectors.selectContentCardDefaultsForPointSystem(state, pointSystemId),
    cardPointData: selectors.selectCardPointDataForCardAndPointSystem(state, cardId, pointSystemId),
    cardPointAdvancedData: selectors.selectCardPointAdvancedDataForCardAndPointSystem(
      state,
      cardId,
      pointSystemId,
    ),
    contentViewPlan,
    dampingCoefficients,
    canEdit: isCurrentUserEditor,
    canEditCommentActivities: isCurrentUserEditorOrCanComment,
    canEditAllCommentActivities: isCurrentUserManager,
    currentUser,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onUpdate: entryActions.updateCurrentCard,
      onMove: entryActions.moveCurrentCard,
      onTransfer: entryActions.transferCurrentCard,
      onDelete: entryActions.deleteCurrentCard,
      onArchive: entryActions.archiveCurrentCard,
      onUserAdd: entryActions.addUserToCurrentCard,
      onUserRemove: entryActions.removeUserFromCurrentCard,
      onBoardFetch: entryActions.fetchBoard,
      onLabelAdd: entryActions.addLabelToCurrentCard,
      onLabelRemove: entryActions.removeLabelFromCurrentCard,
      onLabelCreate: entryActions.createLabelInCurrentBoard,
      onLabelUpdate: entryActions.updateLabel,
      onLabelMove: entryActions.moveLabel,
      onLabelDelete: entryActions.deleteLabel,
      onTaskCreate: entryActions.createTaskInCurrentCard,
      onTaskUpdate: entryActions.updateTask,
      onTaskMove: entryActions.moveTask,
      onTaskDelete: entryActions.deleteTask,
      onAttachmentCreate: entryActions.createAttachmentInCurrentCard,
      onAttachmentUpdate: entryActions.updateAttachment,
      onAttachmentDelete: entryActions.deleteAttachment,
      onActivitiesFetch: entryActions.fetchActivitiesInCurrentCard,
      onActivitiesDetailsToggle: entryActions.toggleActivitiesDetailsInCurrentCard,
      onCommentActivityCreate: entryActions.createCommentActivityInCurrentCard,
      onCommentActivityUpdate: entryActions.updateCommentActivity,
      onCommentActivityDelete: entryActions.deleteCommentActivity,
      onContentCardDefaultsFetch: entryActions.fetchContentCardDefaultsInCurrentBoard,
      onCardPointDataFetch: entryActions.fetchCardPointDataInCurrentCard,
      onCardPointDataUpsert: entryActions.upsertCardPointDataInCurrentCard,
      onCardPointDataComplete: entryActions.completeCardPointDataInCurrentCard,
      onCardPointDataUncomplete: entryActions.uncompleteCardPointDataInCurrentCard,
      onCardPointAdvancedDataFetch: entryActions.fetchCardPointAdvancedDataInCurrentCard,
      onCardPointAdvancedDataCreate: entryActions.createCardPointAdvancedDataInCurrentCard,
      onCardPointAdvancedDataUpdate: entryActions.updateCardPointAdvancedData,
      onCardPointAdvancedDataDelete: entryActions.deleteCardPointAdvancedData,
      push,
    },
    dispatch,
  );

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...omit(dispatchProps, 'push'),
  onClose: () => dispatchProps.push(Paths.BOARDS.replace(':id', stateProps.boardId)),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CardModal);
